import { ApiCampaign } from "src/api/types";
import useApi from "src/hooks/api/utils/useApi";

type CampaignOptions = {
	id: string;
};

export default function useCampaign({ id }: CampaignOptions) {
	const { state, actions, api } = useApi(
		{ id: `CAMPAIGN_${id}` },
		{
			baseUrl: `/campaigns/${id}`,
		}
	);

	const unsubscribe = async () => {
		await api.post("/unsubscribe");
	};

	return {
		campaign: (state?.data || {}) as ApiCampaign,
		status: state.status,
		actions: {
			...actions,
			unsubscribe,
		},
	};
}
